import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import { GET_COORDINATE_DELEGATE_LIST, fetchAuthReport, getCoordinatorDelegateListUrl, GET_DELEGATE_DASHBOARD, getDelegateDashboardUrl, headers, GET_DELEGATE_BADGE_ACTION_TYPE, getDelegateRegistrationCredetialsUrl, DELEGATE_GET_CREDENTIALS } from "../../../utils/constants";



export const getDelegateDashboard_action = (flag,) => async (dispatch) => {
    console.log('JJJ', JSON.parse(sessionStorage.getItem('loginDataSS')))
    try {
        const params = {
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            DelegateRegistrationID: flag == true ? JSON.parse(sessionStorage.getItem('SelectedDelegateDataSS')).DelegateRegistrationID : JSON.parse(sessionStorage.getItem('DelegateDataSS')).DelegateRegistrationID,
            AccountID: flag == true ? JSON.parse(sessionStorage.getItem('SelectedDelegateDataSS')).AccountID : JSON.parse(sessionStorage.getItem('DelegateDataSS')).AccountID,
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
        }
        console.log("getVisitorDashboard_action Action------->", params)

        const res = await axiosGet(getDelegateDashboardUrl, params, headers)

        dispatch({
            type: GET_COORDINATE_DELEGATE_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getDelegateRegistrationCredentials_action = (AccountID) => async (dispatch) => {

    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            AccountID: AccountID ? AccountID : JSON.parse(sessionStorage.getItem('loginDataSS')).AccountID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
        }
        console.log("getVisitorRegistrationCredentials_action Action------->", params)

        const res = await axiosGet(getDelegateRegistrationCredetialsUrl, params, headers)

        dispatch({
            type: DELEGATE_GET_CREDENTIALS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}


export const getCoordinatorDelegate_action = (CoordinatorRegistrationID) => async (dispatch) => {

    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            CoordinatorRegistrationID: CoordinatorRegistrationID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
        }
        console.log("getVisitorRegistrationCredentials_action Action------->", params)

        const res = await axiosGet(getCoordinatorDelegateListUrl, params, headers)

        dispatch({
            type: GET_COORDINATE_DELEGATE_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

// export const getVisitorBadge_action = (flag) => async (dispatch) => {
//     try {
//         var list = [];
//         const mapdata1 = {
//             "ParameterName": "@ExhibitionID",
//             "ParameterValue": sessionStorage.getItem('sessionExhibitionID'),
//             "ParameterDataType": "int"
//         }
//         list.push(mapdata1);
//         const mapdata2 = {
//             "ParameterName": "@VisitorID",
//             // "ParameterValue": JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorID,
//             "ParameterValue": flag == true ? JSON.parse(sessionStorage.getItem('SelectedVisitorDataSS')).ExhVisitorID : JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorID,
//             "ParameterDataType": "int"
//         }
//         list.push(mapdata2);

//         const mapData = {
//             "report_name": badgeReportName,
//             "parameter_details": list
//         }

//         const res = await axiosPost(fetchAuthReport, mapData);

//         dispatch({
//             type: GET_DELEGATE_BADGE_ACTION_TYPE,
//             payload: res,
//         });

//         return Promise.resolve(res);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };